import React from 'react'
import { Icon } from '@chakra-ui/react'

export default (props) => {
  return <Icon {...props} />
}
